import {
  CoverWhaleCoverageList,
  FEE_PER_POWER_UNIT,
} from './constants';

const getFee = (powerUnits) =>
  powerUnits?.filter((veh) => veh.equipment_type === 'Vehicle')
    .length * FEE_PER_POWER_UNIT;

function getPremium(rawCoverages) {
  var totalCost = 0;

  Object.entries(CoverWhaleCoverageList).forEach(([key]) => {
    if (rawCoverages[key]) {
      totalCost += Number(rawCoverages[key].total_cost) || 0;
    }
  });

  return totalCost;
}

function getSubmissionCost(financeDetails) {
  const { downPayment, paymentAmount, numberOfPayments } =
    financeDetails;

  const totalOfPayments =
    Number(paymentAmount) * Number(numberOfPayments);

  const fixedDownPayment = Number(downPayment) || 0;

  return Number((fixedDownPayment + totalOfPayments ?? 0).toFixed(2));
}

export function getCoverages(rawCoverages) {
  var coverages = {};

  Object.entries(CoverWhaleCoverageList).forEach(([key, config]) => {
    if (rawCoverages[key]) {
      coverages[key] = {
        carrier: rawCoverages[key].carrier ?? '',
        value: config.getValue(rawCoverages[key]),
        included: true,
      };
    }
  });

  return coverages;
}

export function getFinanceDetails(quote, feeless) {
  const {
    downPayment,
    paymentAmount,
    numberOfPayments,
    premiumFinanceProvider,
    effectiveAPR,
  } = quote.premiumFinanceDetails;

  const premium = getPremium(quote.coverages);
  const fee = !feeless ? getFee(quote.vehicles) : 0;

  const financeDetails = {
    downPayment: Number(downPayment),
    paymentAmount: Number(paymentAmount),
    effectiveAPR: Number(effectiveAPR),
    numberOfPayments: Number(numberOfPayments),
  };

  const submissionCost = getSubmissionCost(financeDetails);
  const totalCost = submissionCost + fee;

  return {
    premium,
    fee,
    submissionCost,
    totalCost,
    premiumFinanceProvider,
    ...financeDetails,
  };
}
